/**
 * Centralised test-ids for the Player UI (used by Playwright/QA).
 */
export const PLAYER = {
  // Activation
  activationScreen: "player-activation-screen",
  inputActivationKey: "player-activation-key-input",
  btnActivate: "player-activate-btn",
  btnCopyMac: "player-copy-mac-btn",
  macDisplay: "player-mac-display",

  // Intro
  introScreen: "player-intro-screen",
  btnSkipIntro: "player-skip-intro-btn",

  // Main menu
  mainMenu: "player-main-menu",
  tileLiveTv: "tile-live-tv",
  tileMovies: "tile-movies",
  tileSeries: "tile-series",
  tileCatchup: "tile-catchup",
  tileTvGuide: "tile-tv-guide",
  tileSearch: "tile-search",
  tilePlaylists: "tile-playlists",

  // Layout
  topbar: "player-topbar",
  btnNotifications: "player-notifications-btn",
  notificationsBadge: "player-notifications-badge",
  btnSettings: "player-settings-btn",
  btnPlaylistSwitch: "player-playlist-switch-btn",
  btnReloadPlaylist: "player-reload-playlist-btn",
  btnBack: "player-back-btn",

  // Browse
  browseScreen: "player-browse-screen",
  groupItem: (g) => `player-group-${g}`,
  contentItem: (id) => `player-content-${id}`,

  // Watch
  watchScreen: "player-watch-screen",
  videoElement: "player-video-element",
  btnPlayPause: "player-play-pause-btn",
  btnFullscreen: "player-fullscreen-btn",
  // v1.4.62 — Up Next countdown banner (series only)
  upNextBanner: "player-up-next-banner",
  upNextPlayNow: "player-up-next-play-now-btn",
  upNextCancel: "player-up-next-cancel-btn",
  upNextCountdown: "player-up-next-countdown",

  // Search
  searchInput: "player-search-input",

  // TV Guide
  tvGuideScreen: "player-tvguide-screen",
};
